/**
 * mock
 *
 * @author Shigq
 * @date 2021/11/19 15:26
 */
var Mock = require('mockjs')


/**
 * uri
 *
 * @description 将url请求参数转为json格式
 * @param url
 * @returns {{}|any}
 */
function paramObj(url) {
	const search = url.split('?')[1]
	if (!search) {
		return {}
	}
	return JSON.parse(
		'{"' +
		decodeURIComponent(search)
			.replace(/"/g, '\\"')
			.replace(/&/g, '","')
			.replace(/=/g, '":"')
			.replace(/\+/g, ' ') +
		'"}'
	)
}

/**
 * assemble response
 *
 * @param data
 * @param type
 * @returns {*}
 */
function assembleResponse(data, { type = 'success' } = {}) {
	let rspData = {
		header: {
			code: '000000',
			message: 'success'
		}
	}

	if (Object.prototype.toString.call(data) === '[object Array]') {
		rspData = Object.assign({}, rspData, {
			list: data,
			pageInfo: {
				size: 5,
				current: 1,
				total: 2
			}
		})
	} else {
		rspData = Object.assign({}, rspData, data)
	}

	if (type === 'error') {
		rspData = {
			header: {
				code: '000001',
				message: 'test error'
			}
		}
	}

	return rspData
}

function generatorMocks(files) {
	const mocks = []

	files.keys().forEach((key) => {
		mocks.push(...files(key))
	})

	return mocks
}


function mockXHR(mocks) {
	Mock.XHR.prototype.proxy_send = Mock.XHR.prototype.send
	Mock.XHR.prototype.send = function () {
		if (this.custom.xhr) {
			this.custom.xhr.withCredentials = this.withCredentials || false

			if (this.responseType) {
				this.custom.xhr.responseType = this.responseType
			}
		}
		this.proxy_send(...arguments)
	}

	function XHRHttpRequst(respond) {
		return function (options) {
			let result
			if (respond instanceof Function) {
				const { body, type, url } = options
				result = respond({
					method: type,
					body: JSON.parse(body),
					query: paramObj(url),
				})
			} else {
				result = respond
			}
			return Mock.mock(result)
		}
	}

	mocks.forEach((item) => {
		Mock.mock(
			new RegExp(item.url),
			item.type || 'get',
			XHRHttpRequst(item.response)
		)
	})
}

module.exports = {
	assembleResponse,
	generatorMocks,
	mockXHR
}
